import { SVGProps } from "react"

export const LeftOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11.3128 3.41058V2.20277C11.3128 2.09808 11.1925 2.04027 11.1112 2.10433L4.06745 7.60589C4.00761 7.65243 3.95918 7.71203 3.92587 7.78013C3.89256 7.84824 3.87524 7.92305 3.87524 7.99886C3.87524 8.07467 3.89256 8.14949 3.92587 8.21759C3.95918 8.28569 4.00761 8.34529 4.06745 8.39183L11.1112 13.8934C11.194 13.9575 11.3128 13.8996 11.3128 13.795V12.5871C11.3128 12.5106 11.2768 12.4371 11.2175 12.3903L5.59245 7.99964L11.2175 3.60745C11.2768 3.56058 11.3128 3.48714 11.3128 3.41058Z"
      fill="#111827"/>
  </svg>)
